import React from 'react';
import { XIcon, CopyIcon, DownloadIcon } from 'lucide-react';
import { Story } from '../data/mockData';
interface DownloadContentModalProps {
  story: Story;
  onClose: () => void;
}
export function DownloadContentModal({
  story,
  onClose
}: DownloadContentModalProps) {
  const handleCopy = (text: string, label: string) => {
    navigator.clipboard.writeText(text);
    alert(`${label} copied to clipboard!`);
  };
  const handleDownloadImage = () => {
    // For demo purposes, we'll just show an alert
    // In production, you would fetch and download the actual image
    alert('Image download started');
  };
  // Generate a placeholder image URL for demo
  const imageUrl = 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=800&h=600&fit=crop';
  return <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4 backdrop-blur-sm" data-id="element-83">
      <div className="bg-white rounded-2xl max-w-3xl w-full max-h-[90vh] overflow-hidden shadow-card-lg" data-id="element-84">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-neutral-200 px-8 py-6 flex justify-between items-center" data-id="element-85">
          <h2 className="text-2xl font-bold text-display text-neutral-900" data-id="element-86">
            Use this story
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-neutral-100 rounded-lg transition-colors" data-id="element-87">
            <XIcon className="w-6 h-6 text-neutral-600" data-id="element-88" />
          </button>
        </div>
        {/* Content */}
        <div className="overflow-auto max-h-[calc(90vh-180px)] px-8 py-8" data-id="element-89">
          <div className="space-y-6" data-id="element-90">
            {/* Title Section */}
            <div data-id="element-91">
              <div className="flex items-center justify-between mb-2" data-id="element-92">
                <label className="text-base font-semibold text-neutral-900" data-id="element-93">
                  Title
                </label>
                <button onClick={() => handleCopy(story.title, 'Title')} className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium rounded-lg transition-all" style={{
                color: '#0289BB',
                backgroundColor: 'rgba(2, 137, 187, 0.1)'
              }} onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(2, 137, 187, 0.2)'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(2, 137, 187, 0.1)'} data-id="element-94">
                  <CopyIcon className="w-4 h-4" data-id="element-95" />
                  Copy
                </button>
              </div>
              <div className="bg-neutral-100 rounded-lg p-4 border border-neutral-200" data-id="element-96">
                <p className="text-neutral-900" data-id="element-97">{story.title}</p>
              </div>
            </div>
            {/* Body Section */}
            <div data-id="element-98">
              <div className="flex items-center justify-between mb-2" data-id="element-99">
                <label className="text-base font-semibold text-neutral-900" data-id="element-100">
                  Body
                </label>
                <button onClick={() => handleCopy(story.content, 'Body')} className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium rounded-lg transition-all" style={{
                color: '#0289BB',
                backgroundColor: 'rgba(2, 137, 187, 0.1)'
              }} onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(2, 137, 187, 0.2)'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(2, 137, 187, 0.1)'} data-id="element-101">
                  <CopyIcon className="w-4 h-4" data-id="element-102" />
                  Copy
                </button>
              </div>
              <div className="bg-neutral-100 rounded-lg p-4 border border-neutral-200 max-h-64 overflow-auto" data-id="element-103">
                <p className="text-neutral-900 whitespace-pre-wrap" data-id="element-104">
                  {story.content}
                </p>
              </div>
            </div>
            {/* Featured Image Section */}
            <div data-id="element-105">
              <div className="flex items-center justify-between mb-2" data-id="element-106">
                <label className="text-base font-semibold text-neutral-900" data-id="element-107">
                  Featured image
                </label>
                <button onClick={handleDownloadImage} className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium rounded-lg transition-all" style={{
                color: '#0289BB',
                backgroundColor: 'rgba(2, 137, 187, 0.1)'
              }} onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(2, 137, 187, 0.2)'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(2, 137, 187, 0.1)'} data-id="element-108">
                  <DownloadIcon className="w-4 h-4" data-id="element-109" />
                  Download
                </button>
              </div>
              <div className="bg-neutral-100 rounded-lg p-4 border border-neutral-200" data-id="element-110">
                <img src={imageUrl} alt={story.title} className="w-full h-auto rounded-lg" data-id="element-111" />
              </div>
            </div>
          </div>
        </div>
        {/* Footer */}
        <div className="sticky bottom-0 bg-white border-t border-neutral-200 px-8 py-6" data-id="element-112">
          <button onClick={onClose} className="w-full py-4 bg-neutral-100 text-neutral-700 rounded-lg hover:bg-neutral-200 transition-all font-semibold text-lg" data-id="element-113">
            Close
          </button>
        </div>
      </div>
    </div>;
}